import AssignRolesResponsibility from "../../../../components/company/workforce/onboarding/assign-roles-responsibility"

const AssignRolesResponsibilityPage = () => {
    return <AssignRolesResponsibility/>
}

export default AssignRolesResponsibilityPage;